import {OnInit, OnChanges, Component, Input, Output, EventEmitter}
from '@angular/core';

import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';

@Component({
  selector: 'prg-list-selector',
  templateUrl: './list-selector.html',
  // inputs: ['listSource', 'displayField'],
  // outputs: ['selected'],
  styleUrls: [
    './list-selector.css'
  ]
})
export class ListSelectorComponent implements OnInit, OnChanges {

  @Input() listSource: Array<any>;
  @Input() displayField: any;
  @Output() selected: EventEmitter<any>;
  filterText: string;

  constructor() {
    console.log('lstsel: ctor()');
    this.selected = new EventEmitter<any>();
    this.displayField = '';
  }

  ngOnInit() {
    console.log('lstsel: ngoninit');
  }

  ngOnChanges(changes: any) {
    // console.log('lstsel: changes', changes);
  }

  getLabel(item: any) : string {
    if (typeof this.displayField === 'object') {
      for (var i = 0; i < this.displayField.length; ++i) {
        let fld = this.displayField[i];
        if (item[fld]) {
          return item[fld];
        }
      }
    } else {
      return item[this.displayField] || item;
    }
  }

  itemClicked(item: any) {
    this.selected.next(item);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/list-selector/list-selector.ts